import React from "react";
import styled from "styled-components";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

const Home = () => {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Accueil | Les Z'ineuvitables</title>
        <meta
          name="description"
          content="Bienvenue sur le site des Z'ineuvitables, une troupe de théâtre solidaire basée à Neuville-en-Ferrain."
        
        />
                <meta property="og:image" content="https://zineuvitables.org/logo.png" />

      </Helmet>

      <Hero>
        <CoverContent>
          <Title>Les Z'ineuvitables</Title>
          <Subtitle>
            Troupe de théâtre amateur mais avec un gros cœur
          </Subtitle>
          <InfoButton to="/apropos">Découvrir</InfoButton>

        </CoverContent>

      </Hero>
    </>
  );
};

export default Home;

// 🎨 Styled Components

const Hero = styled.div`
  height: 60vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(
      rgba(0, 0, 0, 0.5),
      rgba(0, 0, 0, 0.5)
    ),
    url("/cover-image.jpg") center/cover no-repeat;
  color: #fff;
  text-align: center;
`;

const CoverContent = styled.div`
  max-width: 600px;
  padding: 20px;
  backdrop-filter: blur(5px);
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.5);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
`;

const Title = styled.h1`
  font-size: 2.5rem;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const Subtitle = styled.p`
  font-size: 1.2rem;
  margin-bottom: 30px;

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const InfoButton = styled(Link)`
    margin: 20px;
  padding: 12px 24px;
  background-color: #0056b3;
  color: white;
  text-decoration: none;
  border-radius: 20px;
  border: 2px solid #0056b3;
  font-weight: bold;
  transition: background-color 0.3s ease, color 0.3s ease;

  &:hover {
    background-color: white;
    color: #0056b3;
  }
`;
